import styled from '../../theme/styled'

import { styledComponentWithProps } from '../Styled/Shared'

type HomeProp = {
  home?: boolean
}

export const headerHeight = ({ theme }) => theme.header.height

export const Header = styled.header`
  height: ${headerHeight};
  min-height: ${headerHeight};

  color: ${({ theme }) => theme.header.color};
  background: ${({ theme }) => theme.header.background};

  margin: 0;
  padding-right: 10px;

  .header-pop {
    position: absolute;

    top: 0;
    left: 0;
    right: 0;
    padding-right: 32px;
    height: ${headerHeight};

    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    z-index: 1000;

    box-shadow: 0 0 19px rgba(0, 0, 0, 0.18);
  }

  .header-pop h1 {
    margin-left: 32px;

    img {
      height: 40px;
    }
  }
`

export const HeaderButtons = styled.ul`
  margin-left: auto;
  margin-right: 20px;
  list-style-type: none;
  height: ${headerHeight};
  display: flex;
  flex-direction: row;
  align-items: stretch;

  .spacer200 {
    width: 200px;
  }
`

export const Footer = styled.footer`
  height: 80px;

  width: 100%;
  bottom: 0;

  .center-content {
    width: 100%;
    margin: 0 auto;
    max-width: 1444px;
    padding: 0 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .spacer  {
      flex: 1;
    }
  }
`

export const FooterButtons = styled.div`
  display: inline;
  color: white;

  a {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.invert};
    font-size: 18px;
  }

  strong {
    font-weight: bold;
  }

  a img {
    height: 30px;
    position: relative;
    top: 7px;
  }
`

export const SocialMediaButtons = styled.ul`
  height: ${headerHeight};
  float: right;
  align-items: center;

  a {
    height: ${headerHeight};
    line-height: ${headerHeight};
    display: inline-block;
    align-items: center;
    margin-right: 15px;
  }

  a img {
    position: relative;
    vertical-align: middle;
    height: 30px;
    width: 30px;
  }
`

export const SocialMediaButtonsSmall = styled.ul`
  a {
    display: inline-block;
    align-items: center;
    margin-right: 1rem;
  }

  a img {
    position: relative;
    vertical-align: middle;
    height: 1.2rem;
  }
`

const HomeBg = require('../Home/bckground1440.jpg')

export const LayoutContainer = styledComponentWithProps<HomeProp>(styled.div)`
  min-height: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex: 1 0 100%;

  flex-direction: column;
  background: ${({ home }) =>
    home ? `url(${HomeBg}) 50% 50% / cover` : 'white'};

  .page-main {
    flex-direction: column;
    flex: 1 0 auto;
    display: flex;
  }

  .mainanim-exit-active {
  }

  .mainanim-exit {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Layout/LayoutStyles.ts